<template>
  <div class="mxmed-professionals-section">
    <h5 class="mxmed-section-title">Profissionais</h5>
    <p class="text-gray mxmed-section-desc">
      Mapeie os profissionais Stenci com seus correspondentes no MxMed, procedimentos e convênios.
    </p>

    <div class="loading loading-lg" v-if="loading"></div>
    <template v-else>
      <div class="tile tile-centered tile-alert mb-2" v-if="hasAlert">
        <div class="tile-icon">
          <fa-icon :icon="['far', 'exclamation-triangle']" />
        </div>
        <div class="tile-content">
          <div class="tile-title">Atenção!</div>
          <div>
            Há registros com erros ou alertas.
            <span class="label label-error" v-if="errorCount > 0">
              {{ errorCount === 1 ? '1 erro' : `${errorCount} erros` }}
            </span>
            <span class="label label-warning ml-1" v-if="warningCount > 0">
              {{ warningCount === 1 ? '1 alerta' : `${warningCount} alertas` }}
            </span>
          </div>
        </div>
      </div>

      <table class="table">
        <colgroup>
          <col style="width: 2.4rem">
          <col style="width: 35%">
          <col style="width: 1.4rem">
          <col>
          <col style="width: 5rem">
        </colgroup>
        <thead>
          <tr>
            <th></th>
            <th>Profissional Stenci</th>
            <th></th>
            <th>Profissional MxMed</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <professional-item
            v-for="item in items"
            :key="item.id"
            :professional="item"
            :mappings="mappings"
            :mxmed-professionals="mxmedProfessionals"
            :mxmed-insurances="mxmedInsurances"
            @alert="onAlert"
            @update-mappings="$emit('update-mappings', $event)"
          ></professional-item>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script>
import * as professionalApi from '@/app/professional/api';
import ProfessionalItem from './ProfessionalItem.vue';

export default {
  components: {
    ProfessionalItem,
  },
  props: {
    mappings: {
      type: Object,
      default: null,
    },
    mxmedProfessionals: {
      type: Array,
      default: () => [],
    },
    mxmedInsurances: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      items: [],
      loading: false,
      alerts: {
        error: 0,
        warning: 0,
      },
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    hasAlert() {
      return this.alerts.error > 0 || this.alerts.warning > 0;
    },
    errorCount() {
      return this.alerts.error;
    },
    warningCount() {
      return this.alerts.warning;
    },
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const { items } = await professionalApi.allActive();
        const mappedIds = (this.mappings && this.mappings.professionals)
          ? this.mappings.professionals.map(({ id }) => id)
          : [];

        this.items = items
          .map(item => ({
            id: item.id,
            name: item.name,
            specialty: item.professional && item.professional.specialties
              ? item.professional.specialties[0]
              : null,
          }))
          .sort((a, b) => {
            const aSelected = mappedIds.includes(a.id);
            const bSelected = mappedIds.includes(b.id);
            if (aSelected && !bSelected) return -1;
            if (!aSelected && bSelected) return 1;
            return 0;
          });
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
    },
    onAlert({ type }) {
      if (type in this.alerts) {
        this.alerts[type] += 1;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.mxmed-professionals-section {
  margin-bottom: $layout-spacing-xl;

  .tile-alert {
    background: $orange-color-100;
    border: $border-width solid $orange-color-400;
    border-radius: $border-radius;
    padding: $layout-spacing-lg;

    .tile-icon {
      color: $red-color-500;
      font-size: $layout-spacing-xl;
    }

    .tile-content {
      margin-left: $layout-spacing;

      .tile-title {
        font-weight: 500;
      }
    }
  }

  .table td {
    vertical-align: top;
  }
}
</style>
